(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-options"] && !Shopify.designMode) return;
  try {
    (() => {
  const placeSizeChartLinks = () => {
    document.querySelectorAll('.alex-size-picker .radio__legend').forEach(legend => {
      const productSection = legend.closest('[id^="Product--"]');
      if (!productSection) return;
      const chart = productSection.querySelector('.ks-chart-container');
      if (chart && chart.parentElement !== legend) legend.append(chart);
    });
  };
  const start = () => {
    placeSizeChartLinks();
    const observer = new MutationObserver(placeSizeChartLinks);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', placeSizeChartLinks);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
